import Vue from 'vue'
import Vuex from 'vuex'
import UserService from '@/services/UserService'
import createPersistedState from 'vuex-persistedstate'
import Cookies from 'js-cookie'
import config from'@/config/config'

Vue.use(Vuex)

export default new Vuex.Store({
  strict: true, //debug
  state: {
    name: null,
    email: null,
    token: null,
    loggedIn: false,
    searchInfo: null,
    member: false,
    _id: false,
    alert: null,
    admin: false
  },
  plugins: [createPersistedState({
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: 3, secure: config.secure }),
      removeItem: key => Cookies.remove(key)
    }
})],
  mutations: {
    setAlert (state, status) {
      state.alert = status
    },
    setMember (state, status) {
      state.member = status
    },
    setName (state, status) {
      state.name = status
    },
    setEmail (state, status) {
      state.email = status
    },
    setToken (state, token) {
      state.token = token
    },
    logout (state) {
      state.token = null
      state.member = false
      state.loggedIn = false
      state.name = null
      state.email = null
      state._id = null
      state.admin = false
    },
    login (state, loginObject) {
      state.token = loginObject.token
      state.member = loginObject.member
      state.name = loginObject.name
      state.email = loginObject.email
      state.loggedIn = true
      state._id = loginObject._id
      state.admin = loginObject.admin
    },
    updateUser (state, loginObject) {
      state.member = loginObject.member
      state.name = loginObject.name
      state.email = loginObject.email
    },
    changeSearch (state, search) {
      state.searchInfo = search
    }
  },
  actions: {
    syncMember ({commit, state}) { // Syncs the member data from server with 
      if (state.loggedIn) {
        UserService.verifyMember({
          token: state.token
        })
        .then(response => {
          commit('setMember', response.data)
        })
        .catch(err => {
          alert(err)
        })
      }
    },
    setAlert ({commit}, payload) {
      commit('setAlert', payload)
    },
    setMember ({commit}, payload) {
      commit('setMember', payload)
    },
    setName ({commit}, payload) {
      commit('setName', payload)
    },
    setEmail ({commit}, payload) {
      commit('setEmail', payload)
    },
    setToken ({commit}, token) {
      commit('setToken', token)
    },
    changeSearch ({commit}, search) {
      commit('changeSearch', search)
    },
    logout ({commit}) {
      commit('logout')
    },
    login ({commit}, object) {
      commit('login', object)
    },
    updateUser ({commit}, payload) {
      commit('updateUser', payload)
    }
  },
  modules: {
  },
  getters: {
    getUser(state) {
      return {
        token: state.token,
        name: state.name,
        email: state.email,
        member: state.member,
        validated: state.validated,
        _id: state._id,
        admin: state.admin
      }
    },
    getSearchInfo(state) {
      return state.searchInfo
    },
    loggedIn(state) {
      if (state.loggedIn) {
        return true
      } else {
        return false
      }
    },
    getToken(state) {
      return state.token
    },
    getAlert(state) {
      return state.alert
    }
  }
})
